import { VALIDATION_MESSAGES } from '@zorro/common-utils';
import { Text } from '@zorro/web/design-system';
import { useMonolithQuery } from '@zorro/web/ui-utils';
import { useState } from 'react';
import { UseFormReturn, useWatch } from 'react-hook-form';

import {
  CreateEmployeeFormFields,
  emailValidationSchema,
} from './CreateEmployeeFormUtils';

export const useCompanyEmailAvailability = ({
  control,
  getValues,
  formState: { errors },
}: UseFormReturn<CreateEmployeeFormFields>) => {
  const email = useWatch({ control, name: 'email' });
  const [checkedEmail, setCheckedEmail] = useState<string | null>(null);

  const { data } = useMonolithQuery({
    method: 'employeesControllerCheckCompanyEmailExists',
    params: checkedEmail ? [{ email: checkedEmail }] : null,
    enabled: Boolean(checkedEmail),
  });

  const checkEmailOnBlur = () => {
    const currentEmail = getValues('email');
    if (emailValidationSchema.isValidSync(currentEmail)) {
      setCheckedEmail(currentEmail);
    }
  };

  const isEmailInUse = Boolean(data?.emailInUse) && checkedEmail === email;

  return {
    checkEmailOnBlur,
    isEmailInUse,
    emailInUseMessage: isEmailInUse && !errors.email && (
      <Text c="var(--color-text-error-primary)" my="xs" size="sm">
        {VALIDATION_MESSAGES.emailAlreadyExists}
      </Text>
    ),
  };
};
